export default "__VITE_ASSET__CldHE0RJ__"